import { modalsTariSalud } from '../constants/modalsTariSalud'
import { phoneMask } from './phoneMask'
import { waitForElementToExist } from './waitForElementToExist'
import { observerDatalayer } from './observerDatalayer'

export function tarificatorModals() {
  // Obtén la URL actual
  const currentUrl = window.location.href

  // Itera sobre cada idioma en el objeto de configuración
  Object.entries(modalsTariSalud).forEach(([language, languageConfig]) => {
    const urls = languageConfig.urls

    // Itera sobre las URLs en el idioma actual
    urls.forEach(url => {
      // Compara la URL actual con cada URL en el objeto de configuración
      if (currentUrl.includes(url)) {
        const modalIndex = languageConfig.modalIndex
        // console.log(`El índice del modal para la URL actual (${currentUrl}) en ${language} es: ${modalIndex}`)

        // fuction wait element to exist in DOM
        waitForElementToExist('.teayudamosTarificacionMovil a')
          .then(element => {
            element.addEventListener('click', () => {
              const { DMV, DFI, DVL, DCL } = window
              const arrayModals = DFI.DFI_configuration.modals

              const modal = arrayModals.find(modal => modal.id === modalIndex.toString())
              //Modificamos el modalId correspondiente a la landing de tarificador
              window.dataLayerAdeslas.activeModalId=modal.id
              const { HTMLmodalInShedule, HTMLthankyouInShedule } = modal.config.dmvCustom
              window.WMmodalView = new DMV(HTMLmodalInShedule)
              window.gracias = () => {
                window.WMmodalView.setContent(HTMLthankyouInShedule)
              }

              document.querySelector('#dmv-close.dmv-close').remove()
              window.WMmodalView.open()
              const ringPoolModal = document.querySelector('#wModal .drp-phone')
              // console.log({ ringPoolModal }, phoneMask(DFI.telefonoRingPoolActivo))
              ringPoolModal.textContent = phoneMask(DFI.telefonoRingPoolActivo)
              ringPoolModal.href = 'tel:' + DFI.telefonoRingPoolActivo
              DVL.set.config({ notification: { targetMode: 'nextToTarget', targetSelector: 'input' } })
              DCL.set.forms() //-27/04
            })
          })

        // estando dentro de URLS tarificador miramos dataLayer
        if (typeof window.dataLayerTari === 'undefined') {
          observerDatalayer()
        }
      }
    })
  })
}
